import { gql } from '@apollo/client';

// Pre-delete check for whether a tag is currently in use (tag_mappings cascade-delete).
export const COUNT_TAG_USAGE = gql`
    query CountTagUsage($tag_id: uuid!) {
        tag_mappings_aggregate(where: { tag_id: { _eq: $tag_id } }) {
            aggregate {
                count
            }
        }
    }
`;
